/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowLeftTail = createReactComponent("outline", "arrow-left-tail", "IconArrowLeftTail", [["path", { "d": "M18 12h-15", "key": "svg-0" }], ["path", { "d": "M6 9l-3 3l3 3", "key": "svg-1" }], ["path", { "d": "M21 9l-3 3l3 3", "key": "svg-2" }]]);

export { IconArrowLeftTail as default };
//# sourceMappingURL=IconArrowLeftTail.mjs.map
